import React, { useEffect } from "react";
import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import BottlePour from "@/components/sections/BottlePour";
import Heritage from "@/components/sections/Heritage";
import Origin from "@/components/sections/Origin";
import Product from "@/components/sections/Product";
import Gift from "@/components/sections/Gift";
import Benefits from "@/components/sections/Benefits";
import Culinary from "@/components/sections/Culinary";
import TastingNotes from "@/components/sections/TastingNotes";
import SocialProof from "@/components/sections/SocialProof";
import Award from "@/components/sections/Award";
import Commitment from "@/components/sections/Commitment";
import Shop from "@/components/sections/Shop";
import FAQ from "@/components/sections/FAQ";
import FinalCTA from "@/components/sections/FinalCTA";
import Footer from "@/components/sections/Footer";
import StickyMobileCTA from "@/components/sections/StickyMobileCTA";
import { PRE_HARVEST_MODE } from "@/lib/siteMode";
import Seo, { organizationLd, websiteLd, faqLd, breadcrumbLd, getSiteUrl } from "@/components/Seo";
import { useLang } from "@/i18n/LanguageContext";
import { dict } from "@/i18n/translations";

const SITE_URL = getSiteUrl();

export default function Landing({ forceLang }) {
  const { lang, setLang } = useLang();
  useEffect(() => {
    if (forceLang && forceLang !== lang) setLang(forceLang);
  }, [forceLang, lang, setLang]);
  const effectiveLang = forceLang || lang;
  const isEs = effectiveLang === "es";
  const langDict = dict[effectiveLang] || dict.es;
  const title = isEs
    ? PRE_HARVEST_MODE
      ? "Cortijo Santa María · AOVE de cosecha temprana · Próxima cosecha"
      : "Cortijo Santa María · AOVE Cosecha Temprana Granada · Comprar Online"
    : PRE_HARVEST_MODE
      ? "Cortijo Santa María · Early-Harvest EVOO · Coming soon"
      : "Cortijo Santa María · Early-Harvest EVOO from Granada · Buy Online";
  const description = isEs
    ? PRE_HARVEST_MODE
      ? "AOVE premium de cosecha temprana de Limones, Moclín (Granada). Próxima cosecha en preparación. Déjanos tu email para ser de los primeros en saber cuándo está disponible."
      : "AOVE premium de cosecha temprana, Limones (Granada). Acidez <0,4°. Edición limitada anual. Envío en 2-4 días. Compra directa al productor."
    : PRE_HARVEST_MODE
      ? "Premium early-harvest EVOO from Limones, Moclín (Granada). Next harvest in preparation. Leave your email to be among the first to know when it is available."
      : "Premium early-harvest EVOO from Limones (Granada). Acidity <0.4°. Limited annual edition. Shipping in 2-4 days. Direct from the producer.";
  // Self-referential canonical: `/` for ES, `/en` for EN.
  const canonical = isEs ? `${SITE_URL}/` : `${SITE_URL}/en`;
  const ogImage =
    "https://i.ibb.co/NdQKzXM6/Botella-con-fondo-oscuro-premium-estrecho.png";
  const faq = langDict.faq?.items || [];

  return (
    <>
      <Seo
        title={title}
        description={description}
        canonical={canonical}
        alternates={{
          es: `${SITE_URL}/`,
          en: `${SITE_URL}/en`,
          "x-default": `${SITE_URL}/`,
        }}
        lang={effectiveLang}
        ogImage={ogImage}
        jsonLd={[
          organizationLd(),
          websiteLd(),
          faqLd(faq),
          breadcrumbLd([
            { name: isEs ? "Inicio" : "Home", url: canonical },
          ]),
        ]}
      />
      <main
        data-testid="landing-page"
        className="min-h-screen bg-cream-100 text-charcoal antialiased"
      >
        <Navbar />
        <Hero />
        <BottlePour />
        <Heritage />
        <Origin />
        <Product />
        <Gift />
        <Benefits />
        <Culinary />
        <TastingNotes />
        <SocialProof />
        <Award />
        <Commitment />
        <Shop />
        <FAQ />
        <FinalCTA />
        <Footer />
        <StickyMobileCTA />
      </main>
    </>
  );
}
